/**
 * 去除前后空格
 * @param {string} str
 */
export function regEpxDeleteSpace(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '');
}
/**
 * 检验字符串为正整数
 * @param {string} str
 */
export function regEpxUserNumberInt(str) {
  const userPattern = /^\d+$/;
  return !userPattern.test(str);
}
/**
 * 检验密码格式
 * @param {string} str
 */
export function regEpxUserPassword(str) {
  const passwordPattern = /^[a-zA-Z0-9]{6,16}$/;
  return !passwordPattern.test(str);
} //判断密码格式是否错误
